module.exports = __webpack_public_path__ + "static/blog07-267dfb73b0470781dfc1db78808df199.png";